import { InputLabel, Typography } from "@mui/material";
import { t } from "i18next";
import PropTypes from "prop-types";
import React, { memo } from "react";

const Label = ({ text, required = false, labelProps = {}, htmlFor = "" }) => {
  return (
    <InputLabel
      sx={{
        marginBottom: "5px",
        fontSize: "0.875rem",
        color: "text.slateGray",
        textTransform: "capitalize",
        ...labelProps,
      }}
      htmlFor={htmlFor}
    >
      {t(text)}
      {required && (
        <Typography component={"span"} color={"primary.main"}>
          *
        </Typography>
      )}
    </InputLabel>
  );
};

Label.propTypes = {
  labelText: PropTypes.string.isRequired,
  required: PropTypes.bool,
  labelProps: PropTypes.object,
  htmlFor: PropTypes.string,
};

export default memo(Label);
